import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { Check, Copy } from "@phosphor-icons/react";
import { useState } from "react";
import { useTranslation } from "@/features/utils/i18n";
import { toast } from "sonner";

export const InputCopy = ({
  value,
  toastMessage,
  size = "default",
  className,
}: {
  value: string;
  toastMessage?: string;
  size?: "sm" | "default";
  className?: string;
}) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(value);
    setIsCopied(true);
    toast.success(toastMessage || t("actions.copied"));
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="flex -space-x-px" onClick={copyToClipboard}>
      <Input
        value={value}
        readOnly
        className={cn(
          "font-mono text-sm rounded-r-none",
          size === "sm" && "h-6 text-[10px]! px-2",
          className,
        )}
      />
      <Button
        variant="outline"
        size="default"
        className={cn(
          "shrink-0 rounded-l-none",
          size === "sm" && "h-6 w-6 px-0",
        )}
      >
        {isCopied ? (
          <Check className={size === "sm" ? "h-3! w-3!" : "h-4 w-4"} />
        ) : (
          <Copy className={size === "sm" ? "h-3! w-3!" : "h-4 w-4"} />
        )}
      </Button>
    </div>
  );
};
